<template>
  <div v-if="show">
    <van-notice-bar
      left-icon="volume-o"
      :text="content"
      mode="closeable"
    />
  </div>
</template>

<script>
  import { NoticeBar } from 'vant'

  export default {
    components: {
      [NoticeBar.name]: NoticeBar,
    },
    name: 'notice',
    data() {
      return {
        show: false,
        content: ''
      }
    },
    created () {
      if(localStorage.getItem('commonInformation')){
        this.content = localStorage.getItem('commonInformation')
        this.show = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/notice.vue